import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import BorderButton from "../../../Reuseable/BorderButton/BorderButton";
import ReusableTable from "../../../Reuseable/ReusableTable/ReusableTable";
import ManualCallModal from "../ManualCallModal/ManualCallModal";
import "./ManualCallLogs.scss";
import { fetchManualCallInfo, fetchManualCallLogs } from "../../../store/casesInfoSlice";
import moment from "moment";
import { Skeleton, Tooltip } from "antd";
const ManualCallLogs = ({ caseData }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
 const [openCallScriptModal, setOpenCallScriptModal] = useState(false);
  const { manual_call_logs, manual_call_logs_loading } = useSelector((state) => state.casesInformation)
  const dispatch = useDispatch();
  const [selectedCall, setSelectedCall] = useState(null)
  const [pagination, setPagination] = useState({
    page: 1,
    page_size: 10
  })
  const columns = [
    {
      title: "Date & Time",
      dataIndex: "created_at",
      key: "created_at",
      render: (text) => manual_call_logs_loading ? <Skeleton.Input size="small" active /> : <div style={{ width: "140px" }}>{text ? moment(text).format("MMM D, YYYY – hh:mm A") : 'NA'}</div>,
    },
    {
      title: "Duration",
      dataIndex: "call_duration",
      key: "call_duration",
      render: (text) => manual_call_logs_loading ? <Skeleton.Input size="small" active /> : <div style={{ width: "50px" }}>{text || 'NA'}</div>,
    },
    {
      title: "Agent",
      dataIndex: "caller",
      key: "caller",
      render: (text) => manual_call_logs_loading ? <Skeleton.Input size="small" active /> : <div>{text || 'NA'}</div>,
    },
    {
      title: "Type",
      dataIndex: "call_type",
      key: "call_type",
      render: (status) => (
        manual_call_logs_loading ? <Skeleton.Input size="small" active /> :
          <div
            className={`statusPill ${status === "Call Picked"
              ? "picked"
              : status === "Not Answered"
                ? "notAnswered"
                : status === "Not Reachable"
                  ? "notReachable"
                  : "default"
              }`}
          >
            {status || 'NA'}
          </div>
      ),
    },
   {
    title: "Call Script / Summary",
    dataIndex: "transcript_summary",
    key: "transcript_summary",
    render: (text) => {
      const scriptText =
        text || "The agent tried to confirm whether they were speaking with a person named Kalpana, but the customer replied that they were not, ending the interaction without further discussion.";
      const isLong = scriptText.length > 30;
      const displayText = isLong ? scriptText.slice(0, 30) + "..." : scriptText;

      return manual_call_logs_loading ? (
        <Skeleton.Input size="small" active />
      ) : (
        <Tooltip title={scriptText}>
          <div style={{ display: "inline" }}>
            {displayText}
            {/* {isLong && (
              <span
                onClick={() => setOpenCallScriptModal(true)} // mark state true
                style={{ color: "#1890ff", marginLeft: 4, cursor: "pointer" }}
              >
                more
              </span> */}
            {/* )} */}
          </div>
        </Tooltip>
      );
    },
  },
    {
      title: "Sentiment",
      dataIndex: "sentiment",
      key: "sentiment",
      render: (sentiment) => manual_call_logs_loading ? <Skeleton.Input size="small" active /> : (
        <div
          className={`sentimentTag ${sentiment === "Disengaged"
            ? "disengaged"
            : sentiment === "Irritated"
              ? "irritated"
              : sentiment === "Neutral"
                ? "neutral"
                : sentiment === "Unresponsive"
                  ? "unresponsive"
                  : sentiment === "Avoidant"
                    ? "avoidant"
                    : sentiment === "Interested"
                      ? "interested"
                      : sentiment === "Frustrated"
                        ? "frustrated"
                        : sentiment === "Cooperative"
                          ? "cooperative"
                          : sentiment === "Uncertain"
                            ? "uncertain"
                            : sentiment === "Confident"
                              ? "confident"
                              : sentiment === "Engaged"
                                ? "engaged"
                                : sentiment === "Unavailable"
                                  ? "unavailable"
                                  : sentiment === "Positive"
                                    ? "positive"
                                    : sentiment === "Hopeful"
                                      ? "hopeful"
                                      : "-"
            }`}
        >
          {sentiment || "NA"}
        </div>
      ),
    },
    {
      title: "Predicted Disposition",
      dataIndex: "call_disposition",
      key: "call_disposition",
      render: (text) => manual_call_logs_loading ? <Skeleton.Input size="small" active /> : <div style={{ width: "170px" }}>{text || "NA"}</div>,
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (action, record) => manual_call_logs_loading ? <Skeleton.Input size="small" active /> : (
        <BorderButton
          text="Call Details"
          onClick={() => {
            setIsModalOpen(true);
            setSelectedCall(record);
          }}
        />
      ),
    },
  ];

  useEffect(() => {
    dispatch(fetchManualCallLogs({
      // ...pagination,
      bank_lan: caseData?.loan_no
    }));
  }, [dispatch, pagination, caseData]);

  useEffect(() => {
    if (selectedCall === null) {
      return;
    }
    dispatch(fetchManualCallInfo({
      phone_number: selectedCall?.customer_number
    }))
  }, [dispatch, selectedCall])

  return (
    <div className="manualCallLogsMain">
      <ReusableTable
        columns={columns}
        dataSource={manual_call_logs_loading ? Array(8).fill({}) : manual_call_logs?.results}
        rowKey="key"
        bordered
        pageSize={pagination?.page_size}
        CurrentPageNo={pagination?.page}
        totalItems={manual_call_logs?.count}
        triggerChange={(page, page_size) => {
          setPagination({
            page,
            page_size
          })
        }}
      />
      <ManualCallModal open={isModalOpen}
        onClose={() => {
          setIsModalOpen(false)
          setSelectedCall(null)
        }} callData={selectedCall} />
        
    </div>
  );
};

export default ManualCallLogs;
